import { useSelector } from "react-redux";
import ElementaryPage from "./elementary/ElementaryPage";
import IntermediatePage from "./intermediate/IntermediatePage";
import AdvancedPage from "./advanced/AdvancedPage";

const SyntaxAnalysisPage = ({ setCurrentStep, isPreview }) => {
  const { section } = useSelector((state) => state.assignment);

  if (section?.question.level === "elementary") {
    return (
      <ElementaryPage
        section={section}
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
      />
    );
  } else if (section?.question.level === "intermediate") {
    return (
      <IntermediatePage
        section={section}
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
      />
    );
  } else if (section?.question.level === "advanced") {
    return (
      <AdvancedPage
        section={section}
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
      />
    );
  }
  return <div></div>;
};

export default SyntaxAnalysisPage;
